import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetInvoiceLineItemsParams {
  invoiceId: string;
}

export interface LineItem {
  invoiceId: string;
  upcomingChargeDate: string;
  productName: string;
  type: string;
  amount: string;
}

export const getInvoiceLineItems = async (
  params: GetInvoiceLineItemsParams,
) => {
  const response = await baseAPI.get<Array<LineItem>>(
    `subscription-invoices/lines-items/${params.invoiceId}`,
  );
  return response.data;
};

export const useGetInvoiceLineItems = (params: GetInvoiceLineItemsParams) => {
  return useQuery({
    queryKey: [KEYS.INVOICE_LINE_ITEMS, params.invoiceId],
    queryFn: () => getInvoiceLineItems(params),
    // staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
